import React, { Component, Fragment } from 'react';
import { createStore } from '../store';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

export class Store extends Component {
    static propTypes = {
        reducers: PropTypes.object.isRequired,
        api: PropTypes.func.isRequired,
        onApiError: PropTypes.node,
        children: PropTypes.func,
        middlewares: PropTypes.array
    };

    state = {
        data: null,
        apiError: false,
    };

    get store() {
        return this.state.data ? createStore(this.props.reducers, this.state.data, this.props.middlewares) : null;
    }

    componentDidMount() {
        this.props.api()
            .then(data => {
                this.setState({
                    apiError: false,
                    data,
                });
            })
            .catch(() => this.setState({ apiError: true }));
    }

    render() {
        return this.state.apiError && this.props.onApiError
            ? this.props.onApiError
            : this.state.data ? (
                <Provider store={this.store}>
                    <Fragment>{this.props.children(true)}</Fragment>
                </Provider>
            ) : (
                    this.props.children(false)
                );
    }
}
